import { ReactElement } from 'react'
import { Checkbox, FormControlLabel } from '@mui/material'

interface IsAdminCheckboxFieldProps {
  value: boolean
  onChange: (checked: boolean) => void
  label: string
  dataCy: string
}

const IsAdminCheckboxField = ({
  value,
  onChange,
  label,
  dataCy,
}: IsAdminCheckboxFieldProps): ReactElement => (
  <FormControlLabel
    control={
      <Checkbox
        size="small"
        checked={value}
        onChange={event => onChange(event.target.checked)}
        data-cy={dataCy}
      />
    }
    label={label}
  />
)

export default IsAdminCheckboxField
